import {NavItemDataType} from './NavItemDataType';

export const visibleItems: (items: Array<NavItemDataType>) => Array<NavItemDataType> = (items: Array<NavItemDataType>) => {
    return items.filter(item => !item.inactive).filter(item => showCheckSucceeds(item));
}

const showCheckSucceeds: (navItemData: NavItemDataType) => boolean = (navItemData: NavItemDataType) => {
    return navItemData.show === undefined || navItemData.show
}
